import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, LANGS } from "@/i18n/translations";

const LanguageContext = createContext(null);

const detect = () => {
  const stored = localStorage.getItem("pt_lang");
  if (stored && LANGS.includes(stored)) return stored;
  const nav = (navigator.language || "de").slice(0, 2).toLowerCase();
  return LANGS.includes(nav) ? nav : "de";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detect);

  useEffect(() => {
    localStorage.setItem("pt_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = { lang, setLang, t: translations[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
